<template lang="pug">
article-item-page-template(:title="pageTitle", :loading="loading")
  template(#main)
    .mb-10
      v-img(:src="files + about.banner")
      v-img.mx-auto.my-4(:src="files + about.logo", max-width="400px")
      .ck-content(v-html="about.text")
      .d-flex.justify-center.mt-10
        iframe.page-enem-video.rounded(
          :src="`https://www.youtube.com/embed/${getYoutubeCode(about.video)}`",
          width="100%",
          height="100%",
          frameborder="0",
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
          allowfullscreen
        )
    .mb-10
      .text-center.text-h5.font-weight-bold.mb-3 Links Úteis
      v-sheet.page-enem-links.d-flex.flex-wrap.justify-center.mx-auto(
        max-width="800px"
      )
        v-btn(
          v-for="{ id, title, url } in links",
          :key="id",
          :href="url",
          target="_blank",
          depressed,
          rounded,
          color="primary"
        ) {{ title }}
    .mb-10
      .text-center.text-h5.font-weight-bold.mb-3 Dúvidas Frequentes
      v-expansion-panels
        v-expansion-panel(
          v-for="{ id, question, answer } in doubts",
          :key="id"
        )
          v-expansion-panel-header
            div
              v-icon.mt-n1(small, left) fas fa-question
              span.font-weight-bold.grey--text.text--darken-4 {{ question }}
          v-expansion-panel-content {{ answer }}
  template(#side)
    communications-widget
</template>

<script>
import ArticleItemPageTemplate from "@/components/templates/ArticleItemPage.vue";
import CommunicationsWidget from "@/components/widgets/Communications";
import { getYoutubeCode } from "@/components/utils";

const _config = {
  mods: {
    about: "enemAbout",
    links: "enemLinks",
    doubts: "enemDoubts",
  },
  title: "ENEM",
};

export default {
  data: () => ({
    pageTitle: _config.title,
    loading: true,
  }),
  computed: {
    about() {
      return this.$rest(_config.mods.about).item;
    },
    links() {
      return this.$rest(_config.mods.links).list;
    },
    doubts() {
      return this.$rest(_config.mods.doubts).list;
    },
  },
  methods: {
    getYoutubeCode,
  },
  created() {
    this.loading = true;

    Promise.all([
      this.$rest(_config.mods.about).get({
        keepCache: true,
        save: (state, data) => (state.item = data),
      }),
      this.$rest(_config.mods.links).get({ keepCache: true }),
      this.$rest(_config.mods.doubts).get({ keepCache: true }),
    ])
      .then(() => (this.loading = false))
      .catch(() => {
        this.$router.replace("/error404");
      });
  },
  components: {
    ArticleItemPageTemplate,
    CommunicationsWidget,
  },
};
</script>

<style>
.page-enem-video {
  max-width: 800px;
  width: 100%;
  aspect-ratio: 16 / 9;
}

.page-enem-links {
  gap: 8px;
}
</style>
